import { Chain, getDefaultConfig } from "@rainbow-me/rainbowkit";

const sanko = {
    id: Number(`${process.env.REACT_APP_SANKO_CHAIN_ID}` || 0),
    name: 'Sanko',
    iconUrl: 'https://icons.defined.fi/networks/sanko.png',
    nativeCurrency: { name: 'DMT', symbol: 'DMT', decimals: 18 },
    rpcUrls: {
        default: { http: [`${process.env.REACT_APP_SANKO_RPC}`] },
    }
} as const satisfies Chain;

const arbitrum = {
    id: Number(`${process.env.REACT_APP_ARBITRUM_CHAIN_ID}` || 0),
    name: 'Arbitrum',
    iconUrl: 'https://icons.defined.fi/networks/arbitrum.png',
    nativeCurrency: { name: 'DMT', symbol: 'DMT', decimals: 18 },
    rpcUrls: {
        default: { http: [`${process.env.REACT_APP_ARBITRUM_RPC}`] },
    }
} as const satisfies Chain;


export const wagmiConfig = getDefaultConfig({
    appName: 'Smoove Bridge',
    projectId: `${process.env.REACT_APP_RAINBOW}`,
    chains: [sanko, arbitrum]
});